import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../../../Components/Button/CustomButton";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import * as Yup from "yup";
import { handleAddDiet } from "../../../../APIs/Function/Workout/DietPlans/AddDiet";
import CustomInput from "../../../../Components/input/CustomInput";
import gallery from "../../../../Utils/Images/Gallery Send.png";
import cross from "../../../../Utils/Images/cross.png";
import SelectRecipeModal from "../../../../Components/Modal/SelectRecipe";
import { GetDietCategory } from "../../../../APIs/Function/DietCategory/GetProductCategory";

const AddDietPlans = () => {
  const [tempRecipe, setTempRecipe] = useState();
  const validationSchema = Yup.object().shape({
    title: Yup.string().trim().required("Title is required"),
    image: Yup.mixed().required("Image is required"),
  });
  const [previewImage, setPreviewImage] = useState([]);
  const [recipeType, setRecipeType] = useState(4);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRecipeData, setSelectedRecipeData] = useState([]);
  const [category, setCategory] = useState([]);

  const onClose = () => {
    setOpen(false);
    setRecipeType(4);
    setSearchTerm("");
    setSelectedRecipeData([]);
  };

  const onOpen = () => {
    setOpen(true);
  };

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    image: null,
    recipe_id: [],
    diet_category: "",
  });
  const initialFormData = {
    title: "",
    image: null,
    recipe_id: [],
    diet_category: "",
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSelectRecipes = (selectedRecipes) => {
    const selectedRecipeIds = selectedRecipes.map((recipe) => recipe.id);
    setFormData({
      ...formData,
      recipe_id: selectedRecipeIds,
    });
  };

  const handleImageChange = (event) => {
    const image = event.target.files[0];
    if (image) {
      setFormData({
        ...formData,
        image: image,
      });
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewImage(e.target.result); // Set the data URL as the preview image
      };
      reader.readAsDataURL(image); // Read the file as data URL
    } else {
      setPreviewImage(gallery); // Set the placeholder image if no file is selected
    }
  };

  const handleRemoveRecipe = (recipeIndex) => {
    const updatedTempRecipe = [...tempRecipe];
    updatedTempRecipe.splice(recipeIndex, 1);
    setTempRecipe(updatedTempRecipe);
  };
  const handleSubmit = async (event) => {
    if (formData.recipe_id.length) {
      event.preventDefault();
      try {
        await validationSchema.validate(formData, { abortEarly: false });
        setLoading(true);
        let res = await handleAddDiet(formData);
        setLoading(false);
        if (res.s) {
          alert("Data Added Successfully");
          navigate("/dietplans");
          setFormData(initialFormData);
        } else {
          console.log("API request was not successful:", res.error); // Handle API request errors here
        }
      } catch (error) {
        setLoading(false);
        if (error instanceof Yup.ValidationError) {
          const validationErrors = error.inner.map((e) => e.message);
          alert(validationErrors.join("\n"));
        } else {
          console.log("An unexpected error occurred:", error);
        }
      }
    } else {
      alert("Please Select Recipe");
    }
  };

  const getcategory = async () => {
    try {
      let res = await GetDietCategory();
      console.log(res.r);
      setCategory(res.r);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getcategory();
  }, []);
  console.log("object",formData)
  return (
    <>
      {/* header */}

      <Box>
        <Box
          sx={{
            bgcolor: "#31AEF4",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: { xs: "50px", md: "70px", lg: "70px" },
            p: "10px",
            boxSizing: "border-box",
          }}
        >
          <Link to={"/dietplans"}>
            <Box
              sx={{
                height: { xs: "50px", md: "60px", lg: "60px" },
                display: "flex",
                alignItems: "center",
              }}
            >
              <img height={"100%"} src={backbluebtn} alt="back" />
            </Box>
          </Link>
          <Box>
            <Typography
              sx={{
                fontFamily: "Open Sans",
                fontSize: { md: "30px", sm: "20px" },
                fontWeight: 600,
                lineHeight: "36px",
                color: "#FFFFFF",
              }}
            >
              Add Diet Plan
            </Typography>
          </Box>
          <Box>
            <CustomButton
              disabled={loading}
              sx={{
                width: { xs: "40px", md: "50px", lg: "80px" },
                height: { xs: "10px", md: "50px", lg: "50px " },
              }}
              onClick={handleSubmit}
            >
              {loading ? <CircularProgress></CircularProgress> : "Save"}
            </CustomButton>
          </Box>
        </Box>
        {/* form */}
        <Container sx={{ mt: "10px" }}>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CustomInput
                  label="Title"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <label htmlFor="file-image-input">
                  <Box
                    sx={{
                      width: "100%",
                      height: "150px",
                      bgcolor: "#F4F4F4",
                      p: "20px",
                      boxSizing: "border-box",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center ",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Box sx={{ width: "100px", height: "100px", mb: "10px" }}>
                      <img
                        height={"100%"}
                        width={"100%"}
                        src={previewImage.length ? previewImage : gallery}
                        alt="preview"
                      />
                    </Box>
                    <Typography sx={{}}>Upload Design Image</Typography>
                  </Box>
                </label>
                <input
                  accept="image/*"
                  type="file"
                  id="file-image-input"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
              </Grid>
            </Grid>
          </form>
        </Container>
        <Box>
          <Grid item xs={12}>
            <FormControl
              sx={{ textAlign: "left", width: "90%", m: "auto", mt: "10px" }}
              required
            >
              <InputLabel
                sx={{
                  backgroundColor: "#FFF",
                }}
              >
                Diet Category
              </InputLabel>
              <Select
                name="Diet_Category" // Set a name for the Select component
                value={formData.product_category} // Use the correct value from your form data
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    diet_category: e.target.value,
                  })
                }
                sx={{ textAlign: "left" }}
              >
                {category?.map((e, i) => (
                  <MenuItem key={i} value={e.id}>
                    {e.category}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Box>
        <Box
          sx={{
            height: "380px",
            width: "75%",
            m: "auto",
            border: "0.5px solid #E8E8E8",
            mt: "10px",
            p: 2,
            overflow: "auto",
            boxSizing: "border-box",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "left" }}>
            <CustomButton onClick={onOpen} sx={{ width: "20%" }}>
              Select Recipes +
            </CustomButton>
          </Box>
          <Grid sx={{ mt: "15px" }} container>
            {/* first column */}
            <Grid item xs={0.5} md={0.5}>
              {tempRecipe?.map((e, i) => (
                <Paper
                  key={i}
                  sx={{
                    borderRadius: "0px",
                    border: "1px solid #EFEFEF",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                    }}
                  >
                    {i + 1}
                  </Typography>
                </Paper>
              ))}
            </Grid>

            {/* Second Column */}

            <Grid item xs={2} md={2}>
              {tempRecipe?.map((e, i) => (
                <Paper
                  key={i}
                  sx={{
                    borderRadius: "0px",
                    border: "1px solid #EFEFEF",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box sx={{ width: "40px", height: "40px" }}>
                    <img
                      width={"100%"}
                      height={"100%"}
                      src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${e.recipe_images[0].r_images}`}
                      alt=""
                    />
                  </Box>
                </Paper>
              ))}
            </Grid>

            {/* Third Column */}

            <Grid item xs={7.5} md={7.5}>
              {tempRecipe?.map((e, i) => (
                <Paper
                  key={i}
                  sx={{
                    borderRadius: "0px",
                    border: "1px solid #EFEFEF",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      maxWidth: "100%",
                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    {e.title}
                  </Typography>
                </Paper>
              ))}
            </Grid>

            {/* Sixth Column */}
            <Grid item xs={2} md={2}>
              {tempRecipe?.map((e, i) => (
                <Paper
                  key={i}
                  sx={{
                    borderRadius: "0px",
                    border: "1px solid #EFEFEF",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      sx={{
                        height: "30px",
                        cursor: "pointer",
                        width: "30px",
                      }}
                      onClick={() => handleRemoveRecipe(i)}
                    >
                      <img
                        width={"100%"}
                        height={"100%"}
                        src={cross}
                        alt="preview"
                      />
                    </Box>
                  </Box>
                </Paper>
              ))}
            </Grid>
          </Grid>
        </Box>

        <SelectRecipeModal
          tempRecipe={tempRecipe}
          setTempRecipe={setTempRecipe}
          open={open}
          recipeType={recipeType}
          setRecipeType={setRecipeType}
          onClose={onClose}
          onSelectRecipes={handleSelectRecipes}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          loading={loading}
          setLoading={setLoading}
          selectedRecipeData={selectedRecipeData}
          setSelectedRecipeData={setSelectedRecipeData}
        />
      </Box>
    </>
  );
};

export default AddDietPlans;
